import { render } from "./FilterBarComponent.vue?vue&type=template&id=64951e2c"
import script from "./FilterBarComponent.vue?vue&type=script&lang=js"
export * from "./FilterBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Local Sites/heritage-af3/app/public/wp-content/plugins/af3-shortcodes-1.2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__